import { render, staticRenderFns } from "./PasswordRepair.vue?vue&type=template&id=12e8a842&scoped=true"
import script from "./PasswordRepair.vue?vue&type=script&lang=ts"
export * from "./PasswordRepair.vue?vue&type=script&lang=ts"
import style0 from "./PasswordRepair.vue?vue&type=style&index=0&id=12e8a842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8a842",
  null
  
)

export default component.exports